import one from '../the img/one.jpg'
import two from '../the img/two.jpg'
import three from '../the img/three.jpg'
import four  from '../the img/four.jpg'
import five from '../the img/five.jpg'
import six from '../the img/six.jpg'
import seven from '../the img/seven.jpg'


export default [one, two, three, four, five, six,seven]